import HttpMethods from "../../../Services/httpMethods";
import { makeRequest } from "../../../Services/restcall";
import { ApiResponse } from "../../../Services/types";
export async function GetProductsAPI(categoria?: string, nombre?: string): Promise<ApiResponse> { 
    const params: Record<string, string> = {}; 
    if (categoria) params.categoria = categoria;
    if (nombre) params.nombre = nombre;
    return await makeRequest(HttpMethods.GET, '/api/commerce/products', params)
}
export async function PosProductsAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.POST, '/api/commerce/create-products',value)
}
export async function updateProductaAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.PUT, '/api/commerce/update-product', value)
}
export async function deleteProductoAPI(id:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.DELETE, '/api/commerce/delete-product', { id })
}